import { render, staticRenderFns } from "./upFileA.vue?vue&type=template&id=4e1a9604&"
import script from "./upFileA.vue?vue&type=script&lang=js&"
export * from "./upFileA.vue?vue&type=script&lang=js&"
import style0 from "./upFileA.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports